export const POS_MISSING_MAPPING = 'POS_MISSING_MAPPING';
export const POS_OFFLINE = 'POS_OFFLINE';
export const POS_WRONG_ITEM = 'POS_WRONG_ITEM';
export const POS_RESOURCES_NOT_SET = 'POS_RESOURCES_NOT_SET';

/** `pos_resource.type` values POS Menu Settings supports. Adding one needs a POS_LOGOS entry. */
export const SUPPORTED_POS_TYPES = ['squareapp', 'clover'];
